const PLACEHOLDERS = [
  "/placeholders/ph-pill-bottle.png",
  "/placeholders/ph-blister-pack.png",
  "/placeholders/ph-vial.png",
  "/placeholders/ph-inhaler.png",
  "/placeholders/ph-cream-tube.png",
  "/placeholders/ph-iv-bag.png",
  "/placeholders/ph-eye-drops.png",
  "/placeholders/ph-patch.png",
  "/placeholders/ph-prefilled-syringe.png",
  "/placeholders/ph-powder-sachet.png",
  "/placeholders/ph-liquid-bottle.png",
  "/placeholders/ph-nasal-spray.png",
];

export function getProductPlaceholder(
  productId: number,
  dosageForm?: string | null,
  route?: string | null,
): string {
  const form = (dosageForm || "").toUpperCase();
  const rt = (route || "").toUpperCase();

  if (
    rt.includes("INTRAVENOUS") ||
    rt.includes("INTRA-VENOUS") ||
    rt.includes("INFUSION") ||
    form.includes("INFUSION")
  ) {
    return "/placeholders/ph-iv-bag.png";
  }

  if (
    rt.includes("INTRAMUSCULAR") ||
    rt.includes("SUBCUTANEOUS") ||
    rt.includes("INTRADERMAL") ||
    rt.includes("INTRAARTICULAR") ||
    form.includes("INJECTION") ||
    form.includes("INJECTABLE")
  ) {
    if (form.includes("PREFILLED") || form.includes("PRE-FILLED") || form.includes("SYRINGE")) {
      return "/placeholders/ph-prefilled-syringe.png";
    }
    return "/placeholders/ph-vial.png";
  }

  if (
    rt.includes("INHALATION") ||
    rt.includes("RESPIRATORY") ||
    form.includes("INHALATION") ||
    form.includes("AEROSOL") ||
    form.includes("INHALER") ||
    form.includes("NEBULIZER")
  ) {
    return "/placeholders/ph-inhaler.png";
  }

  if (
    rt.includes("NASAL") ||
    rt.includes("INTRANASAL") ||
    form.includes("NASAL")
  ) {
    return "/placeholders/ph-nasal-spray.png";
  }

  if (
    rt.includes("OPHTHALMIC") ||
    rt.includes("OTIC") ||
    rt.includes("AURICULAR") ||
    form.includes("OPHTHALMIC") ||
    form.includes("OTIC") ||
    form.includes("EYE") ||
    form.includes("EAR") ||
    form.includes("DROPS")
  ) {
    return "/placeholders/ph-eye-drops.png";
  }

  if (
    rt.includes("TRANSDERMAL") ||
    form.includes("PATCH") ||
    form.includes("TRANSDERMAL")
  ) {
    return "/placeholders/ph-patch.png";
  }

  if (
    rt.includes("TOPICAL") ||
    rt.includes("CUTANEOUS") ||
    form.includes("CREAM") ||
    form.includes("OINTMENT") ||
    form.includes("GEL") ||
    form.includes("LOTION") ||
    form.includes("FOAM") ||
    form.includes("TOPICAL")
  ) {
    return "/placeholders/ph-cream-tube.png";
  }

  if (
    form.includes("POWDER") ||
    form.includes("SACHET") ||
    form.includes("GRANULE")
  ) {
    return "/placeholders/ph-powder-sachet.png";
  }

  if (
    form.includes("SOLUTION") ||
    form.includes("SYRUP") ||
    form.includes("ELIXIR") ||
    form.includes("SUSPENSION") ||
    form.includes("LIQUID")
  ) {
    return "/placeholders/ph-liquid-bottle.png";
  }

  if (
    form.includes("CAPSULE") ||
    form.includes("TABLET") ||
    form.includes("LOZENGE") ||
    form.includes("CHEWABLE") ||
    form.includes("CAPLET") ||
    form.includes("PILL") ||
    rt.includes("ORAL")
  ) {
    // "PACK" alone is too broad (matches "PACKET", "PACKAGE") — only treat as
    // a blister when the form explicitly says BLISTER or UNIT-DOSE.
    if (form.includes("BLISTER") || form.includes("UNIT-DOSE") || form.includes("UNIT DOSE")) {
      return "/placeholders/ph-blister-pack.png";
    }
    return "/placeholders/ph-pill-bottle.png";
  }

  return PLACEHOLDERS[Math.abs(productId) % PLACEHOLDERS.length];
}
